<template>
    <div class="cooperation">
       <div class="header" :style="{background: 'url('+url+'/assets/cooperation/cooperation-banner.png) no-repeat'}"></div>
       <div class="content">
           <p class="position">您所在的位置：首页 > 合作伙伴</p>
           <div class="main">
               <p class="title1">合作伙伴</p>
               <p class="title2">每一次的合作，都是一种信任！服务领域包括互联网、电商、教育、医疗、旅游、娱乐、交通、母婴、餐饮、农业、科研等行业。我们期待与更多的创新型企业成为持续发展的战略伙伴</p>
               <div class="list">
                   <div class="img" v-for="(item, index) in list" :key="index">
                       <img :src="item">
                   </div>
               </div>
           </div>
       </div>
        <foot></foot>
    </div>
</template>
<script>
import defaultSettings from '@/defaultSettings'
const img1 = defaultSettings.url + '/assets/cooperation/logo1.png'
const img2 = defaultSettings.url + '/assets/cooperation/logo2.png'
const img3 = defaultSettings.url + '/assets/cooperation/logo3.png'
const img4 = defaultSettings.url + '/assets/cooperation/logo4.png'
const img5 = defaultSettings.url + '/assets/cooperation/logo5.png'
const img6 = defaultSettings.url + '/assets/cooperation/1.jpg'
const img7 = defaultSettings.url + '/assets/cooperation/2.jpg'
const img8 = defaultSettings.url + '/assets/cooperation/3.jpg'
const img9 = defaultSettings.url + '/assets/cooperation/4.jpg'
const img10 = defaultSettings.url + '/assets/cooperation/5.jpg'
const img11 = defaultSettings.url + '/assets/cooperation/1-1.jpg'
const img12 = defaultSettings.url + '/assets/cooperation/1-2.jpg'
const img13 = defaultSettings.url + '/assets/cooperation/1-3.jpg'
const img14 = defaultSettings.url + '/assets/cooperation/1-4.jpg'
const img15 = defaultSettings.url + '/assets/cooperation/1-5.jpg'
const img16 = defaultSettings.url + '/assets/cooperation/1-6.jpg'
const img17 = defaultSettings.url + '/assets/cooperation/1-7.jpg'
const img18 = defaultSettings.url + '/assets/cooperation/1-8.jpg'
import foot from '../components/foot'
export default {
  data() {
    return {
        url: defaultSettings.url,
        list: [
            img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15, img16, img17, img18
        ]
    }
  },
  components: {
    foot
  },
    mounted() {
    window.scrollTo({ left: 0, top: 0 })
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
.cooperation{
    background: #F6F6F6;
    // height:100vh;
    height: 100%;
    position: relative;
    overflow: auto;
    padding-top:90px;
      .header {
        background-size: 100% 100%!important;
        position: relative;
        height:450px;
    }
    .content{
        width:1200px;
        margin:0 auto;
        .position{
            margin-top:25px;
            color:#999999;
            font-size:14px;
            margin-bottom:50px;
        }
        .main{
            text-align: center;
           height:600px;
            .title1{
                font-size:30px;
                color:#333;
                margin-bottom:36px;
            }
            .title2{
                width:600px;
                color:#666;
                font-size:14px;
                text-align: center;
                margin:0 auto;
                margin-bottom:55px;
            }
            .list{
                text-align: left;
                .img{
                    width:220px;
                    height:80px;
                    margin:5px 5px;
                    display: inline-block;
                    img{
                        width:100%;
                        transition: all 0.6s;
                    }
                    img:hover{
                        transition: all 0.6s;
                        transform: translate(0,-8px);
                    }
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/view/cooperation.vue